











































import { Component, Vue } from "vue-property-decorator";
import HeadTitle from "@/components/headerTitle.vue";
import HeadFilter from "./components/filter.vue";
import { columnsList } from "./config";
import { bargainList } from "@/req/dataIndex";
import { gameList } from "@/req/gameManage";
import StatusModal from "./components/StatusModal.vue";
@Component({
  components: {
    HeadTitle,
    HeadFilter,
    StatusModal,
  },
})
export default class Home extends Vue {
  public loading = false;
  public info = {
    game_id: "",
    user_id: "",
    user_account: "",
    seller_user_id: "",
    commodity_id: "",
    status: [],
    s_time: "",
    e_time: "",
    field_str: "counter_offer_time",
  };
  public page = 1;
  public size = 10;
  public columns = columnsList;
  public data: any = [];
  public mounted() {
    this.getGameList();
    this.getList();
  }
  public async getGameList() {
    const res = await gameList({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code == 0) {
      this.$store.state.user.gameList = res.data;
    }
  }
  public toSearch(info) {
    this.info = info;
    this.page = 1;
    this.getList();
  }
  public pageChange(index) {
    this.page = index;
    this.getList();
  }
  public sizeChange(size) {
    this.size = size;
    if (this.page == 1) {
      this.getList();
    }
  }
  public async getList() {
    // this.data = {
    //   data: [
    //     {
    //       game_name: "羽国沉默",
    //       game_id: 9089080,
    //       user_id: 9089080,
    //       user_account: "maijia151521",
    //       seller_user_id: 9089080,
    //       seller_account: "maijia1613515",
    //       commodity_id: "E920037662897020",
    //       status: 1,
    //       state_str: "买家已还价 待买家同意",
    //       buy_sned_time: "2023-09-21 12:00:00",
    //     },
    //   ],
    // };
    this.loading = true;
    const res = await bargainList({
      ...this.info,
      token: this.$fn.cookies.getToken("token"),
      page: this.page,
      size: this.size,
      status: this.info.status.join(","),
    });
    if (res.code == 0) {
      if (res.data.current_page) {
        res.data.current_page = Number(res.data.current_page);
      }
      this.data = res.data;
      this.loading = false;
    }
  }
  public toExportExcel() {
    const windowUrl = this.$fn.exportExcelUrl(
      {
        ...this.info,
        token: this.$fn.cookies.getToken(),
        export: 1,
        page: this.page,
        size: this.size,
      },
      this.$HTTP_API.dataIndex.bargainList
    );
    window.open(windowUrl);
  }
  public onClick(row) {
    const $StatusModal: any = this.$refs.StatusModal;
    $StatusModal.show(row.id, row.status, row.status_txt);
  }
}
